module.exports = __webpack_public_path__ + "img/sfq5.4a23ffc9.png";